<template>
  <div class="size-guide-wrapper">
    <b-container fluid>
      <b-row class="justify-content-center">
        <b-col md="12" class="content-title">
          <h3 class="title-text">{{this.$t('size-guide')}}</h3>
        </b-col>
      </b-row>
      <b-tabs class="tabs-no-skin">
        <b-tab v-for="(tab, index) in tabsToLoad" :key="index" :active="activeTab === index">
          <template slot="title" v-if="$store.state.cms.contents[tab]">
            <span>{{ $store.state.cms.contents[tab].title }}</span>
          </template>
          <cms-content :id="tab" />
        </b-tab>
      </b-tabs>
    </b-container>
  </div>
</template>

<script>
import CmsContent from 'theme/components/Cms/CmsContent'

export default {
  name: 'SizeGuide',
  props: {
    value: {
      type: Boolean,
      required: false
    },
    activeTab: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      tabsToLoad: [
        'pdp-size-guide-block',
        'slim-fitting'
      ]
    }
  },
  methods: {
    loadContent () {
      return this.$store.dispatch('cms/loadContents', this.tabsToLoad)
    }
  },
  components: {
    CmsContent
  }
}
</script>
